

export default {

    computed: {
        /**
         * 商品状态
         */
        getProductStatus() {
            return [{
                label: this.$tc('fbb.setting.goods_status', 0, { defaultValue: '全部' }),
                value: null,
            }, {
                label: this.$tc('fbb.setting.goods_status', 1, { defaultValue: '可用' }),
                value: '1',
            }, {
                label: this.$tc('fbb.setting.goods_status', 2, { defaultValue: '停用' }),
                value: '0',
            }]
        },
        /**
         * 产品类型
         */
        getProductType() {
            return [{
                label: this.$tc('fbb.setting.goods_type', 0, { defaultValue: '成品' }),
                value: '1',
            }, {
                label: this.$tc('fbb.setting.goods_type', 1, { defaultValue: '配件' }),
                value: '2',
            }, {
                label: this.$tc('fbb.setting.goods_type', 2, { defaultValue: '耗材' }),
                value: '3',
            }]
        },
        /**
        * 客退处理方式
        */
        getReturnDealMethod() {
            return [{
                label: this.$tc('fbb.setting.goods_returndeal_method', 0, { defaultValue: '销毁' }),
                value: '0',
            }, {
                label: this.$tc('fbb.setting.goods_returndeal_method', 1, { defaultValue: '销毁' }),
                value: '1',
            }, {
                label: this.$tc('fbb.setting.goods_returndeal_method', 2, { defaultValue: '销毁' }),
                value: '2',
            }]
        },
        /**
        * 快递保价
        */
        getIsInsurance() {
            return [{
                label: this.$tc('fbb.setting.goods_yes', 0, { defaultValue: '是' }),
                value: '1',
            }, {
                label: this.$tc('fbb.setting.goods_no', 1, { defaultValue: '否' }),
                value: '0',
            }]
        },
    }
}
